module.exports = __webpack_public_path__ + "img/logoafp.0c7caa14.jpg";